import Handlebars from "utilities/vendor/handlebars/4.7.8/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.8/js/handlebars";
export default class Templates {
    compile(templateString) {
        return Handlebars.compile(templateString);
    };
};